import React from 'react';
import styled from 'styled-components';

export const TRUST_TAGLINE =
  "Don't cheat. Analyse, learn, grow, analyse again, and make an impact.";

export const TRUST_LINES = [
  'We help you become independent, so you can transform your work and be more productive.',
  'We walk with you on a journey that turns your zeal into impact.',
];

const Wrap = styled.div`
  position: relative;
  z-index: 1;
  margin: ${props => (props.$compact ? '0.75rem 0 0' : '0 0 1.25rem')};
  text-align: ${props => props.$align || 'center'};
`;

const Tagline = styled.p`
  margin: 0;
  font-weight: 700;
  line-height: 1.45;
  color: ${props => (props.$tone === 'light' ? '#fff' : props.theme.colors.primary)};
`;

const Line = styled.p`
  margin: 0.45rem 0 0;
  font-size: 0.92rem;
  line-height: 1.5;
  color: ${props => (props.$tone === 'light' ? 'rgba(255,255,255,0.92)' : props.theme.colors.textLight)};
`;

const TrustPromise = ({ tone = 'dark', align = 'center', compact = false }) => (
  <Wrap $align={align} $compact={compact} role="note">
    <Tagline $tone={tone}>{TRUST_TAGLINE}</Tagline>
    {TRUST_LINES.map((line) => (
      <Line key={line} $tone={tone}>{line}</Line>
    ))}
  </Wrap>
);

export default TrustPromise;
